import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./assets/custom.scss";
import SimpleCounter from "./components/SimpleCounter";
import FunctionalCounterProgressBar from "./components/FunctionalCounterProgressBar";

function App() {
  return (
    <div className="App">
      {/* This component render for UI design only */}
      {/* <SimpleCounter /> */}
      <FunctionalCounterProgressBar />
    </div>
  );
}

export default App;
